export default {
	// Logica del auth
	login(state, payload) {
		let user = payload.Usuario
		let organizadorActivo = payload.OrganizadorActivo
		state.loggedIn = true;
		state.user = user;
		if(Number(organizadorActivo) > 0){
			state.organizadorActivo = organizadorActivo
		} else {
			state.organizadorActivo = null
		}
	},
	logout(state) {
		state.loggedIn = false;
		state.user = null;
		state.organizadorActivo = null;
	},

	// Lógica del modal
	UPDATE_AUTH_MODAL_VISIBILITY(state, authModal) {
		state.authModal.visibility = authModal.visibility;
		const { name, payload } = authModal.callbackAction;
		state.authModal.callbackAction = { name, payload };
	},
	setOrganizadorActivo(state, orAc){
		state.organizadorActivo = orAc
	}
};